import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { BLOG_POSTS } from './blogs/posts'
import { BlogChrome } from './blogs/BlogChrome'
import './blogs/blogs.css'

// 部落格文章列表：/blogs
export default function Blogs() {
  const posts = [...BLOG_POSTS].sort((a, b) => b.date.localeCompare(a.date))
  return (
    <BlogChrome>
      <div className="card border-dark mb-3">
        <div className="blog-wrap blog-wrap-list">
          <Helmet>
            <title>Blog | Feis Studio</title>
          </Helmet>
          {posts.map((p) => (
            <div className="blog-item" key={p.slug}>
              <Link to={`/blogs/${p.slug}`}>{p.title}</Link>
              <div className="blog-date">{p.date}</div>
            </div>
          ))}
        </div>
      </div>
    </BlogChrome>
  )
}
